import { IClassValue } from "../typings/utils";

// Use isTruthy in .filter to get the right type at the exit of the function e.g.:
// [1,2,3,null].filter(v => !!v) <== has type Array<number | null>
// [1,2,3,null].filter(isTruthy) <== has type Array<number>
export function isTruthy<T>(value: T | undefined | null | false | 0 | ""): value is T {
  return !!value;
}

export function cs(...args: IClassValue[]): string {
  return args
    .map((v) => {
      if (Array.isArray(v)) {
        return v[1] ? v[0] : undefined;
      }
      if (v && typeof v === "object") {
        return cs(...Object.keys(v).filter((c) => !!v[c]));
      }
      return v;
    })
    .filter(isTruthy)
    .join(" ");
}
export const classSet = cs;
